import { createAction } from "redux-actions";
import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  apiPostFile,
  apiPutFile,
} from "../../api/index";
import {
  urlCourseSecured,
  urlCourseAllSecured,
  urlCourseAllListSecured,
} from "../../api/urls";
import { PAGE_SIZE_10 } from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.countries !== undefined) filter += "&countries=" + filters.countries;

  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list courses.
 */
export const filterCourse = createAction("FILTER_COURSES", (filter, param) =>
  apiGet(urlCourseAllSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Get a course.
 */
export const get = createAction("GET_COURSE", (param) =>
  apiGet(urlCourseSecured, param, true)()
);

/**
 * Create course.
 */
export const createCourse = createAction("REGISTER_COURSE", (formData) =>
  apiPostFile(urlCourseSecured, formData, undefined, true)()
);

/**
 * Update course.
 */
export const update = createAction("UPDATE_COURSE", (obj, param) =>
  apiPutFile(urlCourseSecured, param, obj, true)()
);

/**
 * Delete course.
 */
export const removeCourse = createAction("DELETE_COURSE", (param) =>
  apiDelete(urlCourseSecured, param, true)()
);

export const listCourses = createAction("FILTER_COURSES", (filter, param) =>
  apiGet(urlCourseAllListSecured + generateFilterQuery(filter), param, false)()
);
